export const COLORS = {
    'blue-link': '#1356DC',
};
export const INSURANCE_PIN_COLORS = {
    valide: ' #558F4F',
    pending: '#3FA3DC',
    rejected: '#F97E7E',
    draft: '#9A9A9A',
}